import { API } from 'aws-amplify';
import axios from 'axios';
import apiConfig from '../config/api';

window.isBytesansokanSe = !window.location.hostname.endsWith(
  'lagenhetsbyte.se'
);

if (window.isDev) console.log('>>> DEBUG MODE <<<');

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function getParameterByName(name) {
  const url = window.location.href;
  const replacedName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${replacedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getRefreshToken() {
  let refreshToken = getParameterByName('auth');

  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  }

  if (!refreshToken) refreshToken = getCookie('refreshToken');
  if (!refreshToken) refreshToken = getCookie('refresh_token');
  if (!refreshToken) refreshToken = localStorage.getItem('refreshToken');

  return refreshToken || null;
}

export function getLoginUrl(propositionId) {
  if (window.isBytesansokanSe) {
    return `https://bjudin.bytesansokan.se/anvandare/logga-in`;
  }

  if (propositionId) {
    return `https://www.lagenhetsbyte.se/bytesansokan/logga-in?returnUrl=https://bytesansokan.lagenhetsbyte.se?propositionid=${propositionId}&errorMessage=N%C3%A5got%20gick%20fel%20vid%20inloggningen%2C%20v%C3%A4nligen%20f%C3%B6rs%C3%B6k%20igen%20lite%20senare.%20Kontakta%20kundtj%C3%A4nst%20om%20felet%20forts%C3%A4tter%20uppst%C3%A5.`;
  }

  return 'https://www.lagenhetsbyte.se/bytesansokan/logga-in?returnUrl=https://bytesansokan.lagenhetsbyte.se&errorMessage=Det%20finns%20ingen%20bytesans%C3%B6kan%20p%C3%A5b%C3%B6rjad%20f%C3%B6r%20denna%20anv%C3%A4ndare.';
}

export function redirectToLoginPage(propositionId) {
  const loginUrl = getLoginUrl(propositionId);
  if (!window.isDev) window.location.href = loginUrl;
}

function createAxiosInstance() {
  const axiosConfig = {
    baseURL: apiConfig.amplifyConfig.API.graphql_endpoint,
    'content-Type': 'application/json',
    withCredentials: true,
  };

  return axios.create(axiosConfig);
}

const axiosInstance = createAxiosInstance();

export async function apiCall(query) {
  return API.graphql(query);
}

export async function init() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    redirectToLoginPage();
  }

  const devParam = getParameterByName('devMode');
  if (devParam === 'true') {
    window.isDev = true;
    localStorage.setItem('devMode', 'true');
  }
}

export default {
  apiCall,
  getLoginUrl,
  init,
};



// WEBPACK FOOTER //
// ./src/services/initiation.js